<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12 xs12>
                    <v-text-field v-model="staff.Username" ref="username" label="User Name" class="input-group--focused" disabled></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12>
                    <v-text-field v-model="staff.Email" label="Email" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12>
                    <v-text-field v-model="staff.FullName" label="Họ tên" class="input-group--focused"></v-text-field>
                </v-flex>
                <v-flex lg12 md12 sm12 xs12>
                    <v-select v-model="staff.RoleID" :items="role_list" item-text="name" item-value="value" label="Quyền hạn" disabled class="input-group--focused"></v-select>
                </v-flex>                
                <v-flex lg12 md12 sm12 xs12>
                    <v-checkbox v-model="change_pass" label="Đổi mật khẩu" class="input-group--focused"></v-checkbox>
                </v-flex> 
                <v-flex lg12 md12 sm12 xs12>
                    <v-text-field v-model="password" type="password" label="Mật khẩu mới" :disabled="!change_pass" class="input-group--focused"></v-text-field>
                </v-flex>
                
                <!-- Two-Factor Authentication Section -->
                <v-flex lg12 md12 sm12 xs12>
                    <v-divider class="my-3"></v-divider>
                    <h3 class="mb-3">Bảo mật 2 lớp (2FA)</h3>
                </v-flex>
                
                <v-flex lg12 md12 sm12 xs12 v-if="!twoFactorEnabled">
                    <v-alert type="info" outlined dense>
                        <strong>Tăng cường bảo mật tài khoản</strong><br>
                        Kích hoạt xác thực 2 lớp để bảo vệ tài khoản của bạn tốt hơn
                    </v-alert>
                    <v-btn color="success" @click="enable2FA" :loading="loading2FA">
                        <v-icon left>fa-shield-alt</v-icon>
                        Kích hoạt 2FA
                    </v-btn>
                </v-flex>
                
                <v-flex lg12 md12 sm12 xs12 v-else>
                    <v-alert type="success" outlined dense>
                        <strong>Đã kích hoạt 2FA</strong><br>
                        Tài khoản của bạn được bảo vệ bởi xác thực 2 lớp
                    </v-alert>
                    <v-btn color="error" outlined @click="showDisable2FADialog = true">
                        <v-icon left>fa-times-circle</v-icon>
                        Tắt 2FA
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card>
        
        <!-- Enable 2FA Dialog -->
        <v-dialog v-model="show2FADialog" max-width="500" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Kích hoạt xác thực 2 lớp</span>
                </v-card-title>
                <v-card-text>
                    <div v-if="!qrCodeVerified">
                        <p><strong>Bước 1:</strong> Tải ứng dụng Google Authenticator trên điện thoại</p>
                        <p><strong>Bước 2:</strong> Quét mã QR dưới đây bằng ứng dụng</p>
                        <div class="text-center my-3">
                            <img :src="qrCodeImage" alt="QR Code" style="max-width: 100%;">
                        </div>
                        <p class="text-center caption">
                            Hoặc nhập mã thủ công: <strong>{{ secretKey }}</strong>
                        </p>
                        <p><strong>Bước 3:</strong> Nhập mã 6 số từ ứng dụng để xác nhận</p>
                        <v-text-field
                            v-model="verifyOTP"
                            label="Mã OTP (6 số)"
                            placeholder="000000"
                            maxlength="6"
                            outlined
                            :error-messages="otpError"
                        ></v-text-field>
                    </div>
                    <div v-else>
                        <v-alert type="success">
                            Xác thực 2 lớp đã được kích hoạt thành công!
                        </v-alert>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancel2FASetup" :disabled="loading2FA">Hủy</v-btn>
                    <v-btn color="primary" @click="verify2FACode" :loading="loading2FA" v-if="!qrCodeVerified">Xác nhận</v-btn>
                    <v-btn color="success" @click="close2FADialog" v-else>Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        
        <!-- Disable 2FA Dialog -->
        <v-dialog v-model="showDisable2FADialog" max-width="400">
            <v-card>
                <v-card-title>
                    <span class="headline">Tắt xác thực 2 lớp</span>
                </v-card-title>
                <v-card-text>
                    <p>Nhập mã OTP để xác nhận tắt 2FA:</p>
                    <v-text-field
                        v-model="disableOTP"
                        label="Mã OTP (6 số)"
                        placeholder="000000"
                        maxlength="6"
                        outlined
                        :error-messages="disableOTPError"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="showDisable2FADialog = false">Hủy</v-btn>
                    <v-btn color="error" @click="disable2FA" :loading="loading2FA">Xác nhận</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</div>
</template>

<script>
import { mapState } from "vuex";
import md5 from "md5";
import configs from "@/configs";
import { sendSuccessNotice, sendErrorNotice } from "@/commons/utils";

export default {
    data() {
        let roles = this.$store.state.roles.all.data.map(obj =>{ 
            var rObj = {};
            rObj['value'] = obj.ID;
            rObj['name'] = obj.RoleName;
            return rObj;
        });
        return {
            role_list: roles,
            password: '',
            change_pass: false,
            show2FADialog: false,
            showDisable2FADialog: false,
            verifyOTP: '',
            disableOTP: '',
            otpError: '',
            disableOTPError: '',
            qrCodeVerified: false
        }
    },
    computed: {
        ...mapState({
            loading: state => state.staff.loading,
            staff: state => state.staff.selected,
            twoFactorEnabled: state => state.authentication.twoFactor.enabled,
            loading2FA: state => state.authentication.twoFactor.loading,
            qrCodeImage: state => state.authentication.twoFactor.qrCode,
            secretKey: state => state.authentication.twoFactor.secret
        }),
        modifyId() {
            return this.$store.state.authentication.user.userid;
        }
    },
    watch: {
        modifyId() {
            this.refreshData();
        }
    },
    methods: {
        refreshData() {
            if (this.modifyId > 0) {
                this.$store.dispatch("staff/getDetail", this.modifyId);
                this.check2FAStatus();
            }
            this.$nextTick(() => this.$refs.username.focus());
        },
        saveData() {
            if(this.change_pass) {
                this.staff.Password = md5(this.password)
            }
            this.$store.dispatch("staff/setDetail", {
                data: this.staff,
                id: this.staff.ID,
                notify: 'Đã cập nhật profile.'
            });
        },
        async check2FAStatus() {
            try {
                await this.$store.dispatch('authentication/check2FAStatus');
            } catch (error) {
                console.error('Check 2FA status error:', error);
            }
        },
        async enable2FA() {
            console.log('Calling enable2FA...');
            try {
                const response = await this.$store.dispatch('authentication/enable2FA');
                console.log('Enable2FA response in Profile:', response);
                console.log('QR Code:', this.qrCodeImage);
                console.log('Secret:', this.secretKey);
                
                if (response && (response.status === 200 || response.status === 'success')) {
                    console.log('Opening dialog...');
                    this.show2FADialog = true;
                    this.verifyOTP = '';
                    this.otpError = '';
                    this.qrCodeVerified = false;
                } else {
                    console.error('Response not success:', response);
                    sendErrorNotice(response && response.message ? response.message : 'Không thể kích hoạt 2FA');
                }
            } catch (error) {
                console.error('Enable2FA catch error:', error);
                sendErrorNotice('Lỗi khi kích hoạt 2FA');
            }
        },
        async verify2FACode() {
            if (!this.verifyOTP || this.verifyOTP.length !== 6) {
                this.otpError = 'Vui lòng nhập mã OTP 6 số';
                return;
            }
            
            this.otpError = '';
            try {
                const response = await this.$store.dispatch('authentication/verify2FACode', this.verifyOTP);
                
                if (response.status === 200 || response.status === 'success') {
                    this.qrCodeVerified = true;
                    sendSuccessNotice('Đã kích hoạt 2FA thành công!');
                } else {
                    this.otpError = response.message || 'Mã OTP không đúng';
                }
            } catch (error) {
                this.otpError = 'Mã OTP không đúng hoặc đã hết hạn';
            }
        },
        async disable2FA() {
            if (!this.disableOTP || this.disableOTP.length !== 6) {
                this.disableOTPError = 'Vui lòng nhập mã OTP 6 số';
                return;
            }
            
            this.disableOTPError = '';
            try {
                const response = await this.$store.dispatch('authentication/disable2FA', this.disableOTP);
                
                if (response.status === 200 || response.status === 'success') {
                    this.showDisable2FADialog = false;
                    this.disableOTP = '';
                    sendSuccessNotice('Đã tắt 2FA');
                } else {
                    this.disableOTPError = response.message || 'Mã OTP không đúng';
                }
            } catch (error) {
                this.disableOTPError = 'Mã OTP không đúng';
            }
        },
        cancel2FASetup() {
            this.show2FADialog = false;
            this.$store.commit('authentication/clear2FAData');
            this.verifyOTP = '';
            this.otpError = '';
            this.qrCodeVerified = false;
        },
        close2FADialog() {
            this.cancel2FASetup();
        }
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.staff.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
